import { type ColumnDef } from "@tanstack/react-table";
import { canSeeAddToCartButton, canSeeWishlistButton } from "~/utils/features";
import { OpenCalcAction } from "~/features/search/components/ProductResults/views/TabularView/ProductTabularViewActionCell/OpenCalcAction";
import { OpenCadAction } from "~/features/search/components/ProductResults/views/TabularView/ProductTabularViewActionCell/OpenCadAction";
import { AddToWishlistAction } from "~/features/search/components/ProductResults/views/TabularView/ProductTabularViewActionCell/AddToWishlistAction";
import { AddToCartAction } from "~/features/search/components/ProductResults/views/TabularView/ProductTabularViewActionCell/AddToCartAction";
import { type SrpProductData } from "~/utils/models";

interface FactoryProps<T> {
  productGetter: (obj: T) => SrpProductData;
  showCalc?: boolean;
}

export function makeTabularViewActionColumnDefinition<T>({
  productGetter,
  showCalc = false,
}: FactoryProps<T>): ColumnDef<T> {
  const isCalcVisible = showCalc;
  const isCADVisible = true;
  const isWishlistVisible = canSeeWishlistButton();
  const isATCVisible = canSeeAddToCartButton();

  const amount = [isCalcVisible, isCADVisible, isWishlistVisible, isATCVisible].filter(Boolean).length;
  const width = 38 * amount;

  return {
    id: "actions",
    header: "",
    meta: { columnType: "action", align: "right", className: "scha__tabular-view__action-cell-bg" },
    accessorFn: productGetter,
    size: width,
    cell: (cell) => {
      const product = cell.getValue() as SrpProductData;
      return (
        <div className={"scha__tabular-view__action-cell"}>
          <div className={"scha__tabular-view__action-cell__inner"}>
            {isCalcVisible && <OpenCalcAction url={product.calcUrl} data-test-id={"tabular-view-action-button-calc"} />}
            {isCADVisible && (
              <OpenCadAction
                url={product.cadUrl}
                hasCad={product.hasCad}
                target={"_blank"}
                data-test-id={"tabular-view-action-button-cad"}
              />
            )}

            {isWishlistVisible && <AddToWishlistAction productCode={product.code} />}

            {isATCVisible && <AddToCartAction productCode={product.code} />}
          </div>
        </div>
      );
    },
  };
}
